import "./_nav.css";

export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
    },
    {
      name: "Licensee",
      url: "/licensee",
      icon: "cui-bookmark",
    },
    {
      name: "Distributors",
      url: "/distributors",
      icon: "fa fa-users fa-lg",
      // children: [
      //   {
      //     name: "Profiles",
      //     url: "/distributors/profile",
      //     icon: "fa fa-file-image-o"
      //   }
      // ]
    },

    {
      name: "Patients",
      url: "/patientusers",
      icon: "fa fa-users fa-lg",
      children: [
        {
          name: "Profiles",
          url: "/patientusers/patientsprofile",
          icon: "fa fa-file-image-o",
        },
        {
          name: "Patient Orders",
          url: "/patientusers/patientorder",
          icon: "nav-icon nav-icon fa fa-circle-o-notch",
        },
        {
          name: "Patient Invoices",
          url: "/patientusers/patientInvoice",
          icon: "fa fa-credit-card custom",
        },
        {
          name: "Patient Payments",
          url: "/patientusers/patientPayment",
          icon: "nav-icon fa fa-cc-mastercard",
        },
      ],
    },
    {
      name: "Chemists",
      url: "/chemistuser",
      icon: "fa fa-users fa-lg",
      children: [
        {
          name: "Profiles",
          url: "/chemistuser/chemistprofile",
          icon: "fa fa-file-image-o",
        },
        {
          name: "Chemist Orders",
          url: "/chemistuser/chemistorders",
          icon: "nav-icon nav-icon fa fa-circle-o-notch",
        },
        {
          name: "Chemist Invoices",
          url: "/chemistuser/chemistInvoice",
          icon: "fa fa-credit-card custom",
        },
        {
          name: "Chemist Payments",
          url: "/chemistuser/chemistPayment",
          icon: "nav-icon fa fa-cc-mastercard",
        },
      ],
    },
    {
      name: "Item Master",
      url: "/itemmaster",
      icon: "fa fa-users fa-lg",
    },
    {
      name: "Product Returns",
      url: "/productreturns",
      icon: "cui-action-undo",
    },
    {
      name: "Credit Notes",
      url: "/creditnotes",
      icon: "cui-calculator ",
    },
    {
      name: "Platform Earnings",
      url: "/platformearnings",
      icon: "nav-icon fa fa-credit-card ",
    },
    {
      name: "Audit Trace",
      url: "/auditTrace",
      icon: "fa fa-search",
    },
    {
      name: "Support",
      url: "/support",
      icon: "nav-icon icon-question",
    },
    {
      name: "Support Users",
      url: "/supportUsers",
      icon: "fa fa-user-circle",
    },
    // {
    //   name: "Feedback",
    //   url: "/feedback",
    //   icon: "icon-note"
    // },
    {
      name: "App Version",
      url: "/appversion",
      icon: "fa fa-share-square-o",
    },
    {
      name: "Batch Admin",
      url: "/batchadmin",
      icon: "fa fa-lock",
    },
    {
      name: "Settings",
      url: "/settings",
      icon: "fa fa-wrench",
      children: [
        {
          name: "Unit",
          url: "/settings/unit",
          icon: "fa fa-barcode",
        },
        {
          name: "Countries",
          url: "/settings/country",
          icon: "icon-location-pin",
        },
        {
          name: "State",
          url: "/settings/state",
          icon: "icon-location-pin",
        },
        {
          name: "District",
          url: "/settings/district",
          icon: "icon-location-pin",
        },
        {
          name: "Currencies",
          url: "/settings/currency",
          icon: "fa fa-money",
        },
        {
          name: "Country Currency",
          url: "/settings/countryCrncy",
          icon: "fa fa-gg-circle",
        },
        {
          name: "Payment Mode",
          url: "/settings/paymentmode",
          icon: "fa fa-credit-card",
        },
        {
          name: "Item Category",
          url: "/settings/itemCategory",
          icon: "fa fa-object-group",
        },
        {
          name: "Delivery Status",
          url: "/settings/deliveryStatus",
          icon: "fa fa fa-truck",
        },
        {
          name: "Support Type",
          url: "/settings/supportType",
          icon: "fa fa-support",
        },
        {
          name: "Brand",
          url: "/settings/brand",
          icon: "fa fa-bitbucket",
        },
        {
          name: "CP Value",
          url: "/settings/Cpvalue",
          icon: "fa fa-calculator",
        },
        {
          name: "Terms & Conditions",
          url: "/settings/termsandcondition",
          icon: "fa fa-thumb-tack",
        },
        {
          name: "Helpline",
          url: "/settings/helpline",
          icon: "fa fas fa-headphones",
        },
        {
          name: "Bank",
          url: "/settings/bank",
          icon: "fa fa-bank",
        },
      ],
    },
    // {
    //   name: "App Version",
    //   url: "/appversion",
    //   icon: "fa fa-share-square-o"
    // }
    // {
    //   name: 'Login',
    //   url: '/login',
    //   icon: 'icon-user',

    // },
  ],
};
